import React from "react";
import { Wrapper } from "../AddressPanel/__styles__/AddressPanel";
import { EmptyState } from "../Common/EmptyState";

const Tasks = () => {
  return (
    <Wrapper>
      <React.Fragment>
        <EmptyState
          icon="no-activity-inbox"
          title="No tasks created"
          body="Add a task to get started!"
        />
      </React.Fragment>
    </Wrapper>
  );
};

export default Tasks;
